// extracted by mini-css-extract-plugin
var _1 = "#ddd";
var _2 = "#ccc";
var _3 = "#4da8d3";
var _4 = "#4da8d3";
var _5 = "#4da8d3";
var _6 = "#ffffff";
var _7 = "#fff";
var _8 = "#0071B8";
var _9 = "0 20px";
var _a = "#eaeaea";
var _b = "#dadada";
var _c = "2px";
var _d = "#0071B8";
var _e = "#4da8d3";
var _f = "#0071B8 !important";
var _10 = "#eaeaea";
var _11 = "#ededed";
export { _1 as "colorBorder", _2 as "colorBorderSecondary", _3 as "colorInfo", _4 as "colorLink", _5 as "colorPrimary", _6 as "layoutBodyBg", _7 as "layoutFooterBg", _8 as "layoutHeaderBg", _9 as "layoutHeaderPadding", _a as "layoutLightSiderBg", _b as "layoutLightTriggerBg", _c as "menuActiveBarHeight", _d as "menuDarkItemBg", _e as "menuDarkItemSelectedBg", _f as "menuDarkSubMenuItemBg", _10 as "menuItemBg", _11 as "tableHeaderBg" }
